export default __webpack_public_path__ + "static/media/spilt-screen-demo.a2385fa4.mp4";